import { render, staticRenderFns } from "./MinhaLojaBanners.vue?vue&type=template&id=12fad982&"
import script from "./MinhaLojaBanners.vue?vue&type=script&lang=js&"
export * from "./MinhaLojaBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports